import { useEffect, useState } from 'react';
import { TextAssetResponse } from '@goldcast/api/content';
import { POST_TO_NAV_MAP } from '../../PostsListPage/constants';

import { useAppContext } from '@/context/AppContext/AppContext';
import { showSuccessToast } from '@/libs/toast/toast';
import useAnalytics from '@/hooks/useAnalytics';
import { copyTextToClipboard } from '@/Pages/PostsListPage/utils';

export enum SharedPostPageAuthState {
  SIGNED_IN,
  SIGNED_OUT,
  SIGNED_IN_WITHOUT_ACCESS
}

export const useSharedPostPageAuthHandler = ({ post }: { post: TextAssetResponse | null }) => {
  const { logger, adminAppStore } = useAppContext();
  const { trackContentShare } = useAnalytics();

  const [authState, setAuthState] = useState<SharedPostPageAuthState>(SharedPostPageAuthState.SIGNED_OUT);

  useEffect(() => {
    if (!post?.content?.organization || !adminAppStore.user?.organization) {
      setAuthState(SharedPostPageAuthState.SIGNED_OUT);
    } else if (adminAppStore.user?.organization === post.content?.organization) {
      setAuthState(SharedPostPageAuthState.SIGNED_IN);
    } else if (adminAppStore.user?.organization) {
      setAuthState(SharedPostPageAuthState.SIGNED_IN_WITHOUT_ACCESS);
    }
  }, [post?.content?.organization, adminAppStore.user?.organization]);

  const handleCopyLink = () => {
    copyTextToClipboard(window.location.href, logger);
    trackContentShare({
      contentType: post?.asset_metadata?.type,
      source: 'SharedPage',
      shareType: 'CopyURL',
      asset: post
    });
    showSuccessToast('Link copied to clipboard!');
  };

  const handleSignInButtonClick = () => {
    window.open(`${window.location.origin}/content/auth/login?redirect=shared/post/${post?.id}`, '_blank');
  };

  const handleSignUpButtonClick = () => {
    const params = new URLSearchParams({
      utm_medium: 'product',
      utm_source: 'contentlab',
      utm_campaign: 'contentlab',
      utm_content: 'share'
    });
    window.open(`${window.location.origin}/content/auth/signup?${params.toString()}`, '_blank');
  };

  const handleEditInContentLabButtonClick = () => {
    window.open(
      `${window.location.origin}/content/auth/login?redirect=content/${post?.content?.project.id}/${
        post?.content?.id
      }/${POST_TO_NAV_MAP[post?.asset_metadata.type]}?activePostId=${post?.id}`,
      '_blank'
    );
  };

  const handleOpenContentLabButtonClick = () => {
    window.open(`${window.location.origin}/content`, '_blank');
  };
  return {
    handleCopyLink,
    authState,
    handleSignInButtonClick,
    handleSignUpButtonClick,
    handleEditInContentLabButtonClick,
    handleOpenContentLabButtonClick
  };
};
